import { useState } from 'react';
import { supabase } from '../supabase';

function SetNewPassword({ onDone }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');

    if (!password || !confirmPassword) {
      setError('Please enter and confirm your new password.');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      onDone();
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #2d2d5e 100%)',
          padding: '32px 24px',
          textAlign: 'center'
        }}>
          <img src={require('../BYG_with_background_color.png')} alt="BYG" style={{ height: '60px', marginBottom: '12px' }} />
          <h1 style={{ color: 'white', fontSize: '20px', margin: '0 0 4px' }}>BYG Deal Desk</h1>
          <p style={{ color: '#c9a84c', fontSize: '13px', margin: 0 }}>Real Estate, Tax Deed and Lien Investing</p>
        </div>

        {/* Form */}
        <div style={{ padding: '24px' }}>
          <h2 style={{ fontSize: '18px', color: '#1a1a2e', marginBottom: '8px', textAlign: 'center' }}>
            Set New Password
          </h2>
          <p style={{ fontSize: '13px', color: '#888', textAlign: 'center', marginBottom: '20px' }}>
            Choose a new password for your account.
          </p>

          {error && (
            <div style={{ backgroundColor: '#fff0f0', border: '1px solid #ffcccc', borderRadius: '6px', padding: '10px 12px', marginBottom: '16px', fontSize: '13px', color: '#c0392b' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '13px', color: '#555', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>New Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="At least 6 characters"
              style={{
                width: '100%', padding: '12px', border: '1px solid #ddd',
                borderRadius: '6px', fontSize: '16px', boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '13px', color: '#555', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Re-enter new password"
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={{
                width: '100%', padding: '12px', border: '1px solid #ddd',
                borderRadius: '6px', fontSize: '16px', boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              width: '100%', padding: '14px', backgroundColor: loading ? '#888' : '#c9a84c',
              color: '#1a1a2e', border: 'none', borderRadius: '6px',
              fontSize: '15px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SetNewPassword;
